<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <v-layout row wrap align-center style="margin-top:20px;">
                    <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 300px">Warehouse - 1</v-btn>
                    <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 20px">Warehouse - 2</v-btn>
                    <v-btn class="primary" v-on:click="sho3()" flat style="margin-left: 20px">Warehouse - 3</v-btn>
                    <v-btn class="primary" v-on:click="sho4()" flat style="margin-left: 20px">Warehouse - 4</v-btn>
                  </v-layout>
                  <v-flex d-flex style="margin-top:40px;margin-bottom:40px">
                    <v-card style="margin-top:20px">
                      <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">Warehouse Booking List</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout row wrap>
                          <v-flex xs3 child-flex>
                            <v-layout row wrap>
                              <label style="margin-top:20px;margin-right: 10px">Show</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                              ></v-overflow-btn>
                              <label style="margin-top:20px;margin-left: 10px">Entries</label>
                            </v-layout>
                          </v-flex>
                          <v-flex xs3 child-flex></v-flex>
                          <v-flex xs6 child-flex>
                            <v-layout row wrap>
                              <v-text-field
                                label="Search"
                              ></v-text-field>
                              <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-data-table
                          :headers="headers"
                          :items="desserts"
                          class="elevation-1"
                          v-show="show1"
                          style="margin-top:20px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.salesorderno }}</td>
                            <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.material}}</a></td>
                            <td class="text-xs-left">{{ props.item.batchno}}</td>
                            <td class="text-xs-left">{{ props.item.productgrade}}</td>
                            <td class="text-xs-left">{{ props.item.qty}}</td>
                            <td class="text-xs-left">{{ props.item.loadingat}}</td>
                            <td class="text-xs-left">{{ props.item.destination}}</td>
                            <td class="text-xs-left">{{ props.item.loadingdate}}</td>
                            <td class="text-xs-left"><a v-on:click="viewtransport()">View Transport</a></td>
                          </template>
                        </v-data-table>
                        <v-data-table
                          :headers="headers"
                          :items="desserts"
                          class="elevation-1"
                          v-show="show2"
                          style="margin-top:20px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.salesorderno }}</td>
                            <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.material}}</a></td>
                            <td class="text-xs-left">{{ props.item.batchno}}</td>
                            <td class="text-xs-left">{{ props.item.productgrade}}</td>
                            <td class="text-xs-left">{{ props.item.qty}}</td>
                            <td class="text-xs-left">{{ props.item.loadingat}}</td>
                            <td class="text-xs-left">{{ props.item.destination}}</td>
                            <td class="text-xs-left">{{ props.item.loadingdate}}</td>
                            <td class="text-xs-left"><a v-on:click="viewtransport()">View Transport</a></td>
                          </template>
                        </v-data-table>
                        <v-data-table
                          :headers="headers"
                          :items="desserts"
                          class="elevation-1"
                          v-show="show3"
                          style="margin-top:20px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.salesorderno }}</td>
                            <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.material}}</a></td>
                            <td class="text-xs-left">{{ props.item.batchno}}</td>
                            <td class="text-xs-left">{{ props.item.productgrade}}</td>
                            <td class="text-xs-left">{{ props.item.qty}}</td>
                            <td class="text-xs-left">{{ props.item.loadingat}}</td>
                            <td class="text-xs-left">{{ props.item.destination}}</td>
                            <td class="text-xs-left">{{ props.item.loadingdate}}</td>
                            <td class="text-xs-left"><a v-on:click="viewtransport()">View Transport</a></td>
                          </template>
                        </v-data-table>
                        <v-data-table
                          :headers="headers"
                          :items="desserts"
                          class="elevation-1"
                          v-show="show4"
                          style="margin-top:20px"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.salesorderno }}</td>
                            <td class="text-xs-left"><a v-on:click="trackbookingno()">{{ props.item.material}}</a></td>
                            <td class="text-xs-left">{{ props.item.batchno}}</td>
                            <td class="text-xs-left">{{ props.item.productgrade}}</td>
                            <td class="text-xs-left">{{ props.item.qty}}</td>
                            <td class="text-xs-left">{{ props.item.loadingat}}</td>
                            <td class="text-xs-left">{{ props.item.destination}}</td>
                            <td class="text-xs-left">{{ props.item.loadingdate}}</td>
                            <td class="text-xs-left"><a v-on:click="viewtransport()">View Transport</a></td>
                          </template>
                        </v-data-table>
                        <v-layout row wrap style="margin-top: 40px">
                          <label style="margin-left:20px">As on Date : </label>
                          <label style="margin-left:40px">Cumulative Inventory: </label>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order No', value: 'salesorderno' },
        { text: 'Material', value: 'material' },
        { text: 'Batch No', value: 'batchno' },
        { text: 'Product Grade', value: 'productgrade' },
        { text: 'Qty', value: 'qty' },
        { text: 'Loading At', value: 'loadingat' },
        { text: 'Destination', value: 'destination' },
        { text: 'Loading Date', value: 'loadingdate' },
        { text: 'Transportation Plan', value: 'transportationplan' }
      ],
      desserts: [
        {
          no: '1',
          salesorderno: '',
          material: '',
          batchno: '',
          productgrade: '',
          qty: '',
          loadingat: '',
          destination: '',
          loadingdate: ''
        },
        {
          no: '2',
          salesorderno: '',
          material: '',
          batchno: '',
          productgrade: '',
          qty: '',
          loadingat: '',
          destination: '',
          loadingdate: ''
        },
        {
          no: '3',
          salesorderno: '',
          material: '',
          batchno: '',
          productgrade: '',
          qty: '',
          loadingat: '',
          destination: '',
          loadingdate: ''
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false
    }
  },
  mounted () {
    console.log('warehouse management page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
      this.show4 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
      this.show4 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
      this.show4 = false
    },
    sho4 () {
      this.show4 = true
      this.show1 = false
      this.show2 = false
      this.show3 = false
    },
    viewtransport () {
      this.$router.push('/Transportplan')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Warehousemanagement.vue